import DateHelper from 'Utility/DateHelper';
import { ISpecialOfferData } from 'Utility/Helpers/IAP/ISpecialOfferData';
import { PopupOfferType } from 'Utility/Helpers/IAP/PopupOffers';
import { cached } from 'Utility/async';
import { SPECIAL_OFFERS } from './IAP/SpecialOffers';

export const SHOP_UNLOCK_LEVEL: number = 4; // unlock immediately *after completing* level

export const STARTER_PACK_OFFER_MIN_PLAY_TIME: number = DateHelper.Day;
export const STARTER_PACK_OFFER_TIME_BETWEEN_SHOW: number = 3 * DateHelper.Day;

export const CACHED_SPECIAL_OFFER_DATA = cached<[PopupOfferType, ISpecialOfferData][]>(() => {
    return (Object.entries(SPECIAL_OFFERS) as unknown) as [PopupOfferType, ISpecialOfferData][];
});
